import { CartaoPeriodoPadrao } from '../shared/enums/cartao-periodo-padrao.enum';
import { BoletoInfo } from './boleto-info';

export class PedidoCadastro {
    public produtoDescricao: string;
    public produtoGuid: string;
    public diasUteis: number;
    pedidoBoletoInfo: BoletoInfo;
    cedenteContratoId0: any;
    cedenteContratoId1: any;
    cedenteContratoId2: any;
    cedenteContratoId3: any;
    produtoGuid2: any[];
    produtoDescricao2: any[];
    cedenteContratoIdArray: any[];
    pedidoId2: number[];
    produtoId: number;
    produtoId2: number[];

    constructor(
        public pedidoId: number,
        public cedenteContratoId: number,
        public valor: number,
        public dataLiberacao: Date,
        public identificacao: string,
        public pedidoItens: PedidoCadastroItem[],
        public pagamento: PedidoPagamento
    ) { }
}

export class PedidoPagamento {
    // utilizado apenas com transferência
    public dadoBancarioGuid: string;
    constructor(
        public meioPagamentoPedidoId: number,
        public valorPagar: number,
        public utilizarSaldo: boolean
    ) { }
}

export class PedidoCadastroItem {
    public statusApp: boolean;
    public descricaoStatusApp: string;
    public matricula: string;
    public nome: string;
    public cpf: string;
    public valorPadrao: number;

    public cartaoPeriodoPadraoId: CartaoPeriodoPadrao;
    public descricaoCartaoPeriodoPadrao: string;
    valorPadrao2: number[];
    cartaoPeriodoPadraoId2: CartaoPeriodoPadrao[];
    descricaoCartaoPeriodoPadrao2: string[];
    cartaoId2: number[];
    valor2: number[];

    constructor(
        public pedidoItemId: number,
        public valor: number,
        public cartaoId: number,
        public comentario: string
    ) { this.valor2 = []; }
}

export class PedidoCadastroItemArquivo {
    constructor(
        public cpf: string,
        public nome: string,
        public sobrenome: string,
        public dataNascimento: Date,
        public telefone: number,
        public valorDisponibilidade: number,
        public matricula: string,
        public centroCusto: string,
        public departamento: string,
        public unidade: string
    ) { }
}